import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {RegistrationSummary} from '../models';

@Injectable({providedIn: 'root'})
export class RegistrationApiService {
  constructor(private http: HttpClient) {}

  getByCatalogKey(organizationId: string, catalogKey: string): Observable<RegistrationSummary[]> {
    return this.http
      .get<{result: RegistrationSummary[]}>(`${environment.apiBaseUrl}/registration/surveys`, {
        headers: {Accept: 'application/vnd.ngin-api.v2, application/json'},
        params: {
          organization_id: organizationId,
          merchant_catalog_key: catalogKey,
          status_not: '-1',
          exclude_forms: 'true',
          fields: 'id,name,survey_url',
        },
        withCredentials: true,
      })
      .pipe(map(({result}) => result));
  }
}
